var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#category--add_svg__clip0_61530_7374)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.249 4.5L10.19 5.558l2.685 2.692-2.685 2.693L11.25 12l3.75-3.75-3.75-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18h-8.25v-3h4.5a1.502 1.502 0 001.5-1.5V3a1.502 1.502 0 00-1.5-1.5H6.75A1.502 1.502 0 005.25 3v10.5a1.502 1.502 0 001.5 1.5h4.5v3H3a1.5 1.5 0 00-1.5 1.5v3H3v-3h8.25v3h1.5v-3H21v3h1.5v-3A1.5 1.5 0 0021 18zM6.75 3h10.5l.002 10.5H6.75V3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category--add_svg__clip0_61530_7374"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCategoryAdd;